"use client"
/* */
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { AlertIcon } from '../AlertIcon/AlertIcon.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { dynamic } from '../../lib/propsContext/dynamicProps/dynamic.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import clsx from 'clsx';
import styles from './Alert.module.scss.mjs';

const Alert = flowComponent("Alert", (props) => {
  const { children, className, status = "info", ref, ...rest } = props;
  const rootClassName = clsx(styles.alert, styles[status], className);
  const propsContext = {
    Heading: {
      className: styles.heading,
      level: 3,
      size: "s",
      children: dynamic((props2) => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(AlertIcon, { status, className: styles.icon }),
        props2.children
      ] }))
    },
    Content: {
      className: styles.content,
      Button: {
        size: "s"
      }
    }
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx("aside", { ...rest, className: rootClassName, ref, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }) }) });
});

export { Alert, Alert as default };
//# sourceMappingURL=Alert.mjs.map
